import { render, staticRenderFns } from "./ShareHub.vue?vue&type=template&id=0c52d530"
import script from "./ShareHub.vue?vue&type=script&lang=js"
export * from "./ShareHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports